import React from 'react';
import CollapsiblePanel from "../../base/CollapsiblePanel";
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import Questions from "./Questions";
import { translate } from "../../base/Translation";
//import { connect } from "react-redux";

/*eslint no-restricted-globals: 0 */

class QuestionGroup extends React.Component {

	removeGroup(evt) {
		if (confirm(translate("Ste si istý?")) === false) return;
		this.props.updateGroup(this.props.group, this.props.section, true);
	}

	onChange(evt) {
		let group = this.props.group;
		group[evt.target.name] = evt.target.value;
		this.props.updateGroup(group, this.props.section, false);
	}


	render() {

		return (
			<CollapsiblePanel title={this.props.group.name ? this.props.group.name : "---"}
				expanded={this.props.group.id < 1} key={this.props.group.id} footer={() => {
					return (
						<div className="text-right">
							<button className="btn btn-danger btn-xs" onClick={this.removeGroup.bind(this)}>
								{translate("Odstrániť skupinu")}
								</button>
						</div>
					)
				}}>
				<Row>
					<Col lg={4} sm={12}>
						<FormGroup className="form-group-sm">
							<ControlLabel>{translate("Názov")}</ControlLabel>
							<FormControl defaultValue={this.props.group.name} onBlur={this.onChange.bind(this)}
								name="name" />
						</FormGroup>
					</Col>
					<Col lg={4} sm={12}>
						<FormGroup className="form-group-sm">
							<ControlLabel>{translate("Bodová váha")}</ControlLabel>
							<FormControl type="number" defaultValue={this.props.group.weight} onBlur={this.onChange.bind(this)}
								name="weight" />
						</FormGroup>
					</Col>
					<Col lg={4} sm={12}>
						<FormGroup className="form-group-sm">
							<ControlLabel>{translate("Poznámka")}</ControlLabel>
							<FormControl defaultValue={this.props.group.note} onBlur={this.onChange.bind(this)}
								name="note" />
						</FormGroup>
					</Col>
					<Col lg={12}>
						<Questions questions={this.props.group.questions}
							section={this.props.section}
							group={this.props.group.id} />
					</Col>
				</Row>
			</CollapsiblePanel>
		)
	}
}

//export default connect(state => ({ }))(QuestionGroup);
export default QuestionGroup;



// WEBPACK FOOTER //
// ./src/modules/form/edit/QuestionGroup.js